import { Button, ButtonSizeTypes, ButtonType, Table, TableColumn, TableMetaProps } from '@digicert/dcone-common-ui'
import React, { ReactElement, useCallback, useEffect, useState } from 'react'
import { Translate } from 'react-localize-redux'
import EditUserSideRail from '../EditUserSideRail'
import { UserUpdateType } from '../user-overview/UserOverview.types'
import styles from './AccessCredentials.module.scss'
import { connect } from 'react-redux'
import { IClientAuth } from 'reducers/Reducers.interfaces'
import { formatDate, translate } from 'shared/helpers/utils'
import { LIMIT_10, LIMIT_MAX } from 'core/utils/constants'
import { DISABLED, EXPIRED, VALID } from 'core/constants'
import moment from 'moment'
import { deleteApiToken } from 'secure-pages/api-tokens/ApiTokens.actions'
import { statusPillRenderer } from 'core/utils/renders.helpers'
import { enableCertificateForUser, fetchClientAuthCerts } from 'secure-pages/client-auth/ClientAuth.actions'
import { ISort } from 'core/actions/Actions.interfaces'
import { parseCertificate } from 'secure-pages/tenants/create-account-sign-in/CertificateParser'

const ClientAuthCertList = ({ user, profile, fetchClientAuthCerts, enableCertificateForUser }): ReactElement => {

  const defaultMeta: TableMetaProps<IClientAuth> = {
    pageSize: LIMIT_10,
    currentPage: 1,
    totalItems: 0,
    filters: {},
    sort: {
      columnKey: "name",
      order: "ascend"
    }
  }

  const [meta,] = useState(defaultMeta)
  const [certificates, setCertificates] = useState([])
  const [showSideRail, setShowSideRail] = React.useState(false)
  const [sideRailContent, setSideRailContent] = useState(UserUpdateType.CreateCertificate)
  const [loading, setLoading] = useState(true)

  const params: ISort = { limit: LIMIT_MAX, offset: 0 }
      params.sort = [
        {
          columnKey: `name:asc`
        }
      ]

  const getIssuerName = (cert: string): any => {
    if (cert) {
      const certificates = parseCertificate(cert)
      if (certificates.length > 0 && certificates[0].isValid) {
        return certificates[0].issuer.components.commonName
      }
    }
  }


  const getTableColumns = (): TableColumn<IClientAuth>[] => [
    {
      key: 'name',
      title: translate('common.form.name') as string,
      sorter: false,
      displayRowActions: true,
      render: cert => (
        <>
          {cert.name}
        </>

      )
    },
    {
      key: 'enabled',
      title: translate('common.status') as string,
      sorter: false,
      render: cert => (
        <>{moment.utc(cert.end_date).diff(moment.utc()) < 0 ? statusPillRenderer(EXPIRED) : cert.enabled ? statusPillRenderer(VALID) : statusPillRenderer(DISABLED)}</>
      )
    },
    {
      key: 'start_date',
      title: translate('common.form.validFrom') as string,
      sorter: false,
      render: cert => (
        <>{formatDate(cert.start_date)}</>
      )

    },
    {
      key: 'end_date',
      title: translate('common.form.validTo') as string,
      sorter: false,
      render: cert => (
        <>{cert.end_date ? formatDate(cert.end_date) : '-'}</>
      )

    },
    {
      key: 'enrollment_method',
      title: translate('clientAuth.issuedFrom') as string,
      sorter: false,
      render: cert => (
        <>{cert.enrollment_method}</>
      )
    },
    {
      key: 'serial_number',
      title: translate('certificates.serialNumber') as string,
      sorter: false,
      render: cert => (
        <>{cert.serial_number}</>
      )
    },
    {
      key: 'x509_cert',
      title: translate('common.form.IntermediateCA') as string,
      sorter: false,
      render: cert => (
        <>{getIssuerName(cert.x509_cert)}</>
      )
    }
  ]

  const tableChange = useCallback(
    () => {
      console.log('Waiting on backend to sort')
    },
    []
  )

  useEffect(() => {
    setLoading(false)
    if (profile.id === user.id) {
      fetchClientAuthCerts(params, profile.id, {}).then(res => {
        setCertificates(res.items)
      })
    }
  }, [])

  const onUploadAction = (): void => {
    setShowSideRail(true)
    setSideRailContent(UserUpdateType.UploadCertificate)
  }

  const onCreateAction = (): void => {
    setShowSideRail(true)
    setSideRailContent(UserUpdateType.CreateCertificate)
  }
  const onEnableDisableCert = (item: IClientAuth) => {
      const payload = {
        enabled: !item?.enabled
      }
      enableCertificateForUser(payload, item.id, user?.id, 'standard').then(() => {
        fetchClientAuthCerts(params, user?.id).then(
          (response: any) => {
            if (response) {
              setCertificates(response.items)
            }
          }
        )
      })
    }

  const getRowActions = (item) => {
    return [
      {
        title: !item.enabled ? translate('clientAuth.enable') : translate('clientAuth.disable'),
        isVisible: true,
        onClick: () => onEnableDisableCert(item)
      }
    ]
  }

  return (
    <section className={styles.accessCredentials}>
      <header className={styles.header}>
        <div>
          <h3><Translate id='clientAuth.label' /></h3>
        </div>
        {profile.id === user.id &&
          <div className={styles.actions}>
            <Button buttonType={ButtonType.SECONDARY} size={ButtonSizeTypes.SMALL} onClick={onUploadAction}><Translate id='clientAuth.uploadBtn' /></Button>
            <Button size={ButtonSizeTypes.SMALL} onClick={onCreateAction}><Translate id='clientAuth.createBtn' /></Button>
          </div>
        }
      </header>
        <Table
          className={styles.table + ' ' + 'resizable-table-body'}
          columns={getTableColumns()}
          items={certificates}
          getRowKey={api => api.id}
          getActions={(item) => getRowActions(item)}
          actionsButtonsQuantity={0}
          meta={meta}
          onChange={tableChange}
          disableCheckBoxes
          loading={loading}
        />
      <EditUserSideRail
        user={user}
        showSideRail={showSideRail}
        sideRailContent={sideRailContent}
        setShowSideRail={setShowSideRail}
        certificates={certificates}
        setCertificates={setCertificates}
      />
    </section>
  )
}
export default connect(null, { fetchClientAuthCerts, deleteApiToken, enableCertificateForUser })(ClientAuthCertList);